module.exports = __webpack_public_path__ + "static/media/television.1f44a753.svg";